<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar
      :background-color="sidebarBackground"
      short-title="Transmall"
      title="Transmall"
    >
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Dashboard',
            icon: 'ni ni-tv-2 text-primary',
            path: '/dashboard'
          }"
        />
        <sidebar-item :link="{name: 'User Management', icon: 'fas fa-users text-pink', path: '/userManagement'}" v-if="this.$auth.check('admin')"/>
        <sidebar-item :link="{name: 'Coupons', icon: 'fas fa-ticket-alt text-orange', path: '/coupons'}"  v-if="this.$auth.check('admin')"/>
          <sidebar-item :link="{name: 'Shopping Orders', icon: 'fas fa-shopping-basket text-green', path: '/ShoppingOrders'}" v-if="this.$auth.check('admin')"/>
        <sidebar-item :link="{name: 'Add Products', icon: 'fas fa-file-medical text-blue', path: '/addProducts'}" v-if="this.$auth.check('admin')" />
          <sidebar-item :link="{name: 'System Logs', icon: 'fas fa-clipboard-check text-teal', path: '/systemLog'}" v-if="this.$auth.check('admin')" />
        <sidebar-item :link="{name: 'All Products', icon: 'fas fa-shopping-cart text-black', path: '/allProducts'}" v-if="this.$auth.check('admin')"/>
        <sidebar-item :link="{name: 'Add My Products', icon: 'fas fa-file-medical text-green', path: '/addMyProducts'}" v-if="this.$auth.check(['retailer','wholesaler'])"/>
        <sidebar-item :link="{name: 'All My Products', icon: 'fas fa-shopping-cart text-teal', path: '/allMyProducts'}" v-if="this.$auth.check(['retailer','wholesaler'])"/>
        <sidebar-item :link="{name: 'My Shopping Orders', icon: 'fas fa-shopping-basket text-orange', path: '/MyShoppingOrders'}" v-if="this.$auth.check(['retailer','wholesaler'])"/>
        <sidebar-item :link="{name: 'Shipping Orders', icon: 'fas fa-shipping-fast text-purple', path: '/Delivery'}" v-if="this.$auth.check('rider')" />
        <sidebar-item :link="{name: 'Categories', icon: 'fas fa-list', path: '/categories'}" v-if="this.$auth.check('admin')"/>
        <sidebar-item :link="{name: 'User Profile', icon: 'ni ni-single-02 text-yellow', path: '/profile'}"/>
      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import { FadeTransition } from 'vue2-transitions';

  export default {
    components: {
      DashboardNavbar,
      ContentFooter,
      FadeTransition
    },
    data() {
      return {
        sidebarBackground: 'vue' //vue|blue|orange|green|red|primary
      };
    },
    methods: {
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      }
    }
  };
</script>
<style lang="scss">
</style>
